import React, { useState, useEffect, useMemo } from 'react';
import { useSelector,shallowEqual ,useDispatch}      from 'react-redux';
import { RootState } from '../../store';
import { getImage,getImageSpeaker } from '../../utils/helper.ts';
import { highlightTitle } from '../../utils/htmlHelper.tsx';



interface AboutProps {
    landingPageData: any; 
    label: string;
          
  }
 
const Speaker:React.FC <AboutProps> = ({landingPageData,label}) => {
    const speakers = useSelector((state: RootState) => state.eventData.speakers);
    const eventData = useSelector((state: any) => state.eventData); 
    const text = landingPageData?.keynote_speaker_text || '';
    const eventTitle = eventData?.title || '';
    console.log("Speakers Data:======>", landingPageData);
     
    if(speakers.length === 0){return null}
    return (
        <div className="single-section speaker-area" id="speakers">
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        {/* Section Heading */}
                        <div className="section-heading">
                            <h2 className="section-title" style={{
   '--before-bg': eventData.primary_color
  }}>{label}</h2>
                            <p className="section-description col-lg-12 col-md-10 col-sm-12">
                                 {highlightTitle(text, eventTitle)}
                                
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="container">
                <div className="row">
                    {speakers && speakers.length > 0 ? (

                        speakers.map((spk: any, index: number) => (
                            <div className="speaker-item col-lg-4 col-md-6 col-sm-12" key={index}>
                                <div className="img-item">
                                    <ul className="social-icons" style={{ background:eventData.primary_color }}>
                                        <li><a href={spk.facebook_profile || "#0"} target="_blank" rel="noopener noreferrer" title="Facebook"><i className="icon-facebook"></i></a></li>
                                        <li><a href={spk.linkedin_profile || "#0"} target="_blank" rel="noopener noreferrer" title="LinkedIn"><i className="icon-linkedin-1"></i></a></li>
                                        <li><a href={spk.twitter_profile || "#0"} target="_blank" rel="noopener noreferrer" title="Twitter"><i className="icon-twitter"></i></a></li>
                                    </ul>
                                    <img src={getImageSpeaker(spk?.profile_picture?.key, spk?.salutation) || "images/default-speaker.jpg"} alt={spk.first_name} />
                                </div>
                                <div className="speaker-detail">
                                    <div className="speaker-caption">
                                        <h4 className="name">{spk.first_name} {spk.last_name}</h4>
                                        <h5 className="job-title">{spk.job_title}</h5>
                                        <h6 className="job-title">{spk?.company_name}</h6>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="text-center w-100">No speakers found.</p>
                    )}
                </div>
            </div>
        </div>
    );
};

export default Speaker;
